module.exports = __webpack_public_path__ + "static/ionicons-2c159d0d05473040b53ec79df8797d32.woff";